import $ from "jquery";

/**
 * Read a cookie value by name (returns "" when absent).
 */
function getCookie(name) {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : "";
}

/**
 * Foundation form: client-side validation + submission through the WP AJAX
 * proxy (action: foundation_form_submit), which forwards to HubSpot server-side.
 */
export default class FormFoundation {
  constructor($el) {
    this.$el = $el && $el.length ? $el : $("section.form-foundation");
    if (!this.$el.length) return;

    this.$form = this.$el.find(".leadFormFoundation");
    if (!this.$form.length) return;

    this.init();
  }

  init() {
    const self = this;

    // Clear error styling/messages as the user corrects a field.
    this.$form.on("input change", "input, textarea", function () {
      $(this).removeClass("input-error");
      $(this).siblings(".input-error-message").remove();
    });

    this.$form.find('input[name="privacy_policy"]').on("change", function () {
      if ($(this).is(":checked")) {
        $(this).closest(".gchoice").find(".input-error-message").remove();
      }
    });

    this.$form.on("submit", function (e) {
      e.preventDefault();
      if (!self.validate()) return;
      self.submit();
    });
  }

  validate() {
    const $form = this.$form;
    let isValid = true;

    $form.find(".input-error-message").remove();
    $(".form-error").addClass("hidden").html("");

    // Required text inputs (firstname, lastname, jobtitle, phone, organisation, email).
    $form.find('input[aria-required="true"]').each(function () {
      const $field = $(this);
      if ($.trim($field.val()) === "") {
        isValid = false;
        $field.addClass("input-error");
        const msg = $field.attr("data-error") || "This field is required";
        $field
          .closest(".gform-grid-col, .ginput_container")
          .append(`<p class="input-error-message">${msg}</p>`);
      }
    });

    // Email format.
    const $email = $form.find('input[name="email"]');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if ($email.length && !emailPattern.test($email.val())) {
      isValid = false;
      $email.addClass("input-error");
      $email.parent().find(".input-error-message").remove();
      $email
        .parent()
        .append(`<p class="input-error-message">Please enter a valid email address</p>`);
    }

    // Phone format (only validated when something has been entered).
    const $phone = $form.find('input[name="phone"]');
    const phonePattern = /^[0-9+\-\s()]+$/;
    if ($phone.val() && !phonePattern.test($phone.val())) {
      isValid = false;
      $phone.addClass("input-error");
      $phone
        .parent()
        .append(`<p class="input-error-message">Please enter a valid phone number</p>`);
    }

    // Privacy Policy must be accepted.
    const $privacy = $form.find('input[name="privacy_policy"]');
    if (!$privacy.is(":checked")) {
      isValid = false;
      $privacy
        .closest(".gchoice")
        .append(`<p class="input-error-message">You must accept the Privacy Policy</p>`);
    }

    return isValid;
  }

  submit() {
    const $form = this.$form;

    // Grey out the form during submission.
    $form.append(
      '<div id="form-loading" class="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center"></div>'
    );

    $.ajax({
      url: bunkerData.ajaxUrl,
      dataType: "json",
      method: "POST",
      data: {
        action: "foundation_form_submit",
        nonce: bunkerData.ajax_nonce,
        // HubSpot tracking cookie, read client-side so it links the
        // submission to an existing contact (the server-side $_COOKIE read is
        // unreliable behind the CDN). Empty if HS tracking hasn't set it.
        hutk: getCookie("hubspotutk"),
        form_data: {
          firstname: $form.find('input[name="firstname"]').val(),
          lastname: $form.find('input[name="lastname"]').val(),
          email: $form.find('input[name="email"]').val(),
          phone: $form.find('input[name="phone"]').val(),
          jobtitle: $form.find('input[name="jobtitle"]').val(),
          organisation: $form.find('input[name="organisation"]').val(),
          message: $form.find('textarea[name="message"]').val(),
        },
        page_data: {
          id: $form.find('input[name="page_id"]').val(),
          title: $form.find('input[name="page_title"]').val(),
          url: $form.find('input[name="page_url"]').val(),
        },
      },
      success: function () {
        $form.html(
          '<div class="py-8 text-2xl text-center">Thank you for registering your interest. We will be in touch soon.</div>'
        );
        $("html, body").animate({ scrollTop: $form.offset().top - 300 }, 1000);
      },
      error: function (jXHR) {
        $("#form-loading").remove();
        let error = "Something went wrong. Please try again.";
        const data = jXHR.responseJSON;
        if (data && data.errors && data.errors.length) {
          error = data.errors.join("<br/>");
        } else if (data && typeof data.data === "string") {
          error = data.data;
        }
        $(".form-error").removeClass("hidden").html(error);
        $("html, body").animate(
          { scrollTop: $(".form-error").offset().top - 300 },
          1000
        );
      },
    });
  }
}
